import React from "react";
import { connect } from "react-redux";
import { putKeywordList } from "../Actions/KeywordManagementAPI";
import logo from "../Asset/download.jpg";
import API from "../helpers/api";
import axios from "axios";
import { searchCrewMgmt } from "../Actions/CrewManagement";
import Role from "../helpers/role";
import Autocomplete from "react-autocomplete";
import { getShipnameList } from "../Actions/HelpersAPI";
import swal from "sweetalert";
import { getAllRank } from "../Actions/RankManagementAPI";
import { toast } from "react-toastify";
import * as $ from "jquery";
import Modal from "react-bootstrap/Modal";
// import "react-image-crop/dist/ReactCrop.css";
import Demo from "./croppercdn";
import { hideLoader, showLoader } from "../Actions/PageLoaderAPI";

const SearchItem = {
  crewId: "",
  name: "",
  shipName: "",
  designation: "",
  fromDate: "",
  toDate: "",
  designation: "",
  shipId: 0,
  clientId: 0,
  PageNumber: 1,
  PageSize: 25,
};

let userRole = localStorage.getItem("UserRoles");

class CrewEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("currentUser")),
      PhotoFile: "",
      crewData: {
        CrewId: "",
        shipId: 0,
        clientId: 0,
        name: "",
        shipName: "",
        designation: "",
        photo: "",
        photoName: "",
        crewMemberId: "",
        isDeleted: false,
        fileName: "",
        modalIsOpen: false,
        fileName: "",
        src: null,
        imageRef: null,
      },
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.UpdateData = this.UpdateData.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(getShipnameList());
    this.props.dispatch(getAllRank());

  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, crewDetails } = nextProps;
    if (crewDetails && crewDetails !== "") {
      prevState.PhotoFile = crewDetails.photo;
      prevState.crewData.CrewId = crewDetails.crewId;
      prevState.crewData.shipId = crewDetails.shipId;
      prevState.crewData.name = crewDetails.name;
      prevState.crewData.shipName = crewDetails.shipName;
      prevState.crewData.designation = crewDetails.designation ? crewDetails.designation : "";
      prevState.crewData.photoName = crewDetails.photoName;
      prevState.crewData.photo = crewDetails.photo;
      prevState.crewData.crewMemberId = crewDetails.crewMemberId;
      dispatch({ type: "ClientUserDetails", data: "" });
    }
  }

  handleInputFileChange(event) {
    let _this = this;
    let filename = event.target.files[0].name;
    this.state.fileName = filename;
    this.state.ImgSrc = event.target.files[0];
    _this.setState({ modalIsOpen: true })
  } // Image cropper code.

  getBlobData = (file) => {
    let _this = this;
    let finalResult = file.split(",");
    _this.state.PhotoFile = file;
    _this.state.crewData["photo"] = finalResult[1];
    _this.state.crewData["photoName"] = _this.state.fileName;
    _this.setState({});
    this.props.dispatch(hideLoader());
    this.setState({
      modalIsOpen: false
    })
  } // Image cropper code.

  propsImgSrc = (imgsrc) => {
    this.props.dispatch(showLoader());
    this.getBlobData(imgsrc);
  } // Image cropper code.

  ClearInput = () => {
    this.state.crewData.photoName = "";
    this.state.crewData.photo = "";
    this.state.PhotoFile = "";
    this.setState({});
  };

  handleInputChange(e) {
    this.state.crewData[e.target.name] = e.target.value;
    this.setState({});
  }

  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }

  handleAnnualSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.crewData.shipName = e.target.value;
    this.setState({});
  };

  handleAnnualSelectChange = (e, id) => {
    const { dispatch } = this.props;
    this.state.crewData.shipName = e;
    this.state.crewData.shipId = id;
    this.setState({});
  };

  renderRankTitle(state, val) {
    return (state?.rankName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }

  handleAnnualRankSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.crewData.designation = e.target.value;
    this.setState({});
  };

  handleAnnualRankSelectChange = (e, id) => {
    const { dispatch } = this.props;
    let url = `${API.RankExist}?rankId=${id}`;
    axios.get(url)
      .then((response) => {
        if (response.data === false) {
          this.state.crewData.designation = e;
          this.setState({});
        }
        else {
          toast.error("Rank already used", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "getRankExistSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "getRankExistFailure",
          error: "ERROR"
        })
      })
  };

  UpdateData() {
    const { dispatch, history } = this.props;
    if (this.state.crewData.CrewId !== "" && this.state.crewData.name !== "" && this.state.crewData.designation !== "" && this.state.crewData.photoName !== "") {
      let url = `${API.UpdateCrew}`;
      axios
        .put(url, this.state.crewData)
        .then((response) => {
          if (response.status === 400) {
            swal("Error!", response.data, "warning");
          } else if (response.status === 200) {
            dispatch(searchCrewMgmt(SearchItem, 1));
            this.hideSidePanel();
            toast.success("Updated Successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            swal("Error!", error.response.data, "warning");
          } else {
            swal("Error!", "Something went wrong. Please try again.", "warning");
          }
        });
    }
    else {
      swal('Error!', 'Please fill the details', 'warning')
    }
  }

  hideSidePanel = () => {
    //  this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push(`/Home/Management/CrewManagement`);
  };
  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { showSidePane, ShipNameList, AllRank } = this.props;
    return (
      <>
        <div className="full-height">
          <div className="pt-3">
            {/* <imgcrop /> */}

            <div className="row px-3 pb-3">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.BacktoPrevious()}
              >
                <div style={{ position: 'relative' }}>
                  <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
                </div>
              </button>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header mt-2 mb-0"
                    style={{ backgroundColor: "white", border: "0px" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-4 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Update Crew
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row pb-1">
                      <div className="col-sm-2 m-auto text-right">
                        <div className="text-center rounded-circle">
                          <img
                            src={
                              this.state.PhotoFile &&
                                this.state.PhotoFile !== ""
                                ? this.state.PhotoFile
                                : logo
                            }
                            alt="Smiley face"
                            style={{ width: "145px", height: "140px" }}
                            class="rounded-circle"
                          ></img>
                        </div>
                      </div>
                      <div className="col-sm-10">
                        <div className="row">
                          <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                            <label className="form-label">Crew Id</label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name="CrewId"
                              placeholder="Crew Id"
                              value={this.state.crewData.CrewId}
                              disabled={true}
                            ></input>
                          </div>
                          <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                            <label className="form-label">Name</label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name="name"
                              placeholder="Name"
                              value={this.state.crewData.name}
                              onChange={(e) => this.handleInputChange(e)}
                            ></input>
                          </div>
                          {userRole == Role.mmpladmin && (
                            <div
                              className={showSidePane ? "col-lg-4 " : "col-lg-4 "}
                            >
                              <div
                                className="autocomplete-wrappers"
                              // style={{ zIndex: 9999 }}
                              >
                                <label className="form-label">Ship Name</label>
                                <br></br>
                                <Autocomplete
                                  contentEditable={true}
                                  value={this.state.crewData.shipName}
                                  inputProps={{
                                    placeholder: "Ship Name",
                                  }}
                                  items={ShipNameList ?? []}
                                  getItemValue={(item) => item.shipName}
                                  shouldItemRender={this.renderShipNameTitle.bind(
                                    this
                                  )}
                                  renderMenu={(item) => (
                                    <div className="dropdown">{item}</div>
                                  )}
                                  renderItem={(item, isHighlighted) => (
                                    <div
                                      className={`items ${isHighlighted ? "selected-items" : ""
                                        }`}
                                    >
                                      {item.shipName}
                                    </div>
                                  )}
                                  onChange={(e) => this.handleAnnualSearchChange(e)}
                                  onSelect={(e, item) => this.handleAnnualSelectChange(e, item.shipID)}
                                />
                              </div>
                            </div>
                          )}
                          {/* <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                        <label className="form-label">Rank</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="designation"
                          placeholder="Rank"
                          value={this.state.crewData.designation}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                      </div> */}
                          <div
                            className={showSidePane ? "col-lg-4 " : "col-lg-4 "}
                          >
                            <div
                              className="autocomplete-wrappers"
                            // style={{ zIndex: 9999 }}
                            >
                              <label className="form-label">Rank</label>
                              <br></br>
                              <Autocomplete
                                contentEditable={true}
                                value={this.state.crewData.designation}
                                inputProps={{
                                  placeholder: "Rank",
                                }}
                                items={AllRank ?? []}
                                getItemValue={(item) => item.rankName}
                                shouldItemRender={this.renderRankTitle.bind(
                                  this
                                )}
                                renderMenu={(item) => (
                                  <div className="dropdown">{item}</div>
                                )}
                                renderItem={(item, isHighlighted) => (
                                  <div
                                    className={`items ${isHighlighted ? "selected-items" : ""
                                      }`}
                                  >
                                    {item.rankName}
                                  </div>
                                )}
                                onChange={(e) => this.handleAnnualRankSearchChange(e)}
                                onSelect={(e, item) => this.handleAnnualRankSelectChange(e, item.rankId)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <label className="form-label">Photo</label>
                            <br></br>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  Browse File
                                  <input
                                    type="file"
                                    id="files"
                                    title=" "
                                    style={{ marginRight: 40 }}
                                    onChange={(e) => this.handleInputFileChange(e)}
                                    onClick={(event) => {
                                      event.currentTarget.value = null;
                                    }}
                                  />
                                </span>
                              </div>
                              <input
                                type="text"
                                class="form-control"
                                placeholder=""
                                name="username"
                                value={this.state.crewData.photoName}
                              />
                              {this.state.crewData.photoName ? (
                                <div class="input-group-append"
                                  style={{ cursor: "pointer" }}>
                                  <i
                                    class="fa fa-times input-group-text"
                                    aria-hidden="true"
                                    onClick={() => this.ClearInput()}
                                  ></i>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className={userRole == Role.staff ? "col-lg-8 pt-3" : "col-lg-4 pt-3"}>
                            <label></label>
                            <br></br>
                            <div
                              className="search-btn-col"
                              style={{ textAlign: "end" }}
                            >
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                type="submit"
                                onClick={() => this.UpdateData()}
                              >
                                {" "}
                                Update{" "}
                              </button>
                              <button
                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                type="button"
                                onClick={() => this.hideSidePanel()}
                              >
                                {" "}
                                Cancel{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
            </div>
          </div>
        </div>

        <div>
          <Modal
            size="lg"
            show={this.state.modalIsOpen}
            onHide={() => this.setState({ modalIsOpen: false })}
            aria-labelledby="example-modal-sizes-title-sm"
            backdrop="static"
            centered="true"
            animation="true"
          >
            <Modal.Header closeButton>
                Upload crew image
            </Modal.Header>

            <Modal.Body>
              <Demo imageBlob={this.state.ImgSrc} handleImgCrop={this.propsImgSrc} />
            </Modal.Body>
          </Modal>
        </div>
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    crewDetails: state.MasterScreenReducer.ClientUserDetails,
    ShipNameList: state.UserManageReducer.ShipNameList,
    AllRank: state.RankManagementReducer.AllRank || [],
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CrewEdit);